import {
  FETCH_GLOBAL_IMPC_PRESET_PER_ASSET_TYPE_REQUEST,
  FETCH_GLOBAL_IMPC_PRESET_PER_ASSET_TYPE_SUCCESS,
  FETCH_GLOBAL_IMPC_PRESET_PER_ASSET_TYPE_FAILURE,
  FETCH_GLOBAL_OPERATOR_PRESET_PER_ASSET_TYPE_REQUEST,
  FETCH_GLOBAL_OPERATOR_PRESET_PER_ASSET_TYPE_SUCCESS,
  FETCH_GLOBAL_OPERATOR_PRESET_PER_ASSET_TYPE_FAILURE,
} from './types/GlobalPresetPerAssetTypeActionTypes';

export function getGlobalPresetImpcRequestActionCreator(context) {
  return {
    type: FETCH_GLOBAL_IMPC_PRESET_PER_ASSET_TYPE_REQUEST,
    payload: {
      appContext: context,
    },
  };
}

export function getGlobalPresetImpcSuccessActionCreator(data) {
  return {
    type: FETCH_GLOBAL_IMPC_PRESET_PER_ASSET_TYPE_SUCCESS,
    payload: data,
  };
}

export function getGlobalPresetImpcFailureActionCreator(error) {
  return {
    type: FETCH_GLOBAL_IMPC_PRESET_PER_ASSET_TYPE_FAILURE,
    payload: error,
    error: true,
  };
}

export function getGlobalPresetOperatorRequestActionCreator(context) {
  return {
    type: FETCH_GLOBAL_OPERATOR_PRESET_PER_ASSET_TYPE_REQUEST,
    payload: {
      appContext: context,
    },
  };
}

export function getGlobalPresetOperatorSuccessActionCreator(data) {
  return {
    type: FETCH_GLOBAL_OPERATOR_PRESET_PER_ASSET_TYPE_SUCCESS,
    payload: data,
  };
}

export function getGlobalPresetOperatorFailureActionCreator(error) {
  return {
    type: FETCH_GLOBAL_OPERATOR_PRESET_PER_ASSET_TYPE_FAILURE,
    payload: error,
    error: true,
  };
}
